import Sidebar from '../components/sidebar/Sidebar';
import React, {useState} from 'react';
import Footer from '../components/footer/Footer';
import FormsExtensionsDetails from "../components/forms/FormsExtensionsDetails";
import NavbarForms from "../components/navbar/NavbarForms";


const FormExtensions = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    return (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <NavbarForms toggle={toggle} />
          <FormsExtensionsDetails/>
        <Footer/>
      </>
  );
};

export default FormExtensions;
